module.exports = __webpack_public_path__ + "img/AminMusaDPS-new.5d2d3b31.jpg";